import { NewExams } from "../../components/Forms/NewExams";

const NewExamsPage = () => {
  return <NewExams />;
};

export default NewExamsPage;
